import { Menu, MenuItem, Spinner } from '@blueprintjs/core';
import { ItemListRendererProps } from '@blueprintjs/select';
import * as React from 'react';

import { SelectItem } from 'bones/utils/select/types';

export const loadingItemListRenderer = <
  SubItemType extends SelectItem | null,
  ItemType extends SelectItem<SubItemType>
>(
  listProps: ItemListRendererProps<ItemType>
) => (
  <Menu ulRef={listProps.itemsParentRef}>
    <MenuItem text={<Spinner />} />
  </Menu>
);
